export default __webpack_public_path__ + "static/media/Bandipur3.1bc3f8bc.jpg";